
import React, {useEffect, useState} from 'react';


import {
	createPayment_69fce3d85276935741630b32,
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_carriton0fqi,
} from '../../actions/auth.actions';

import {createordenesdecomprabokst } from '../../api/ordenesdecomprabokst.api'

import './carritodecomprasg8pi6.scss';


const loftyShouldRenderCarousel = (products = []) => {
  const loftyIsMobile = window.innerWidth < 464;
  if (loftyIsMobile) {
    return true;
  }
  return products.length > 3;
}


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pcarritodecomprasg8pi6 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_carriton0fqi,
	set_lofty_global_carriton0fqi_app,

}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69e146fbee7dda37b6dcc59b" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i6edva"
          href="/"
        >
          
    <div id="iysqr8" className="">
    <>Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iy44bl"
          href="/menu"
        >
          
    <div id="i41p5g" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyf8jb"
          href="/eventos"
        >
          
    <div id="iztdq8" className="">
    <>Reservaciones</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i377lh"
          href="/unite"
        >
          
    <div id="io6x2g" className="">
    <>Únete a nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i3knlt"
          href="/ubicaciones"
        >
          
    <div id="ie1esj" className="">
    <>Ubicaciones</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="inff1e" className="">
      
        <a
          target=""
          className=""
          id="ijhswy"
          href="/carrito"
        >
          
    <div id="i7kn2y" className="">
    <>Carrito</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Menú</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Eventos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Únete a nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Ubicaciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Carrito</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihk8" className="">
      
      <div id="iym0il" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Haz tu Pedido</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i803s">
        <>Descubre los sabores auténticos de Honduras</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3dh" className="">
      
      <div id="iuax2c" className="">
      
            <div className="" id="igo4ih">
              
      <div id="iqtre8" className="">
      
            {
              lofty_global_carriton0fqi?.map((loftyitemvariable_global_carriton0fqi) => (
                <div className="" id="i5ma07">
                  
      <div id="iotivr" className="">
      <>
        </>
      </div>
      
      <div id="iceaco" className="">
      
        <div className="" id="ix4wpe">
          
          <div className="" id="">
            {loftyitemvariable_global_carriton0fqi?.cartitem?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="i10l98">
          
          <div className="" id="">
            {loftyitemvariable_global_carriton0fqi?.cartitem?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="i5g57q" className="">
      
      <div id="i3pbpu" className="">
      
      <div className="" id="inrben">
        <>L</>
      </div>
      
        <div className="" id="ijsgut">
          
            <div className="" id="">
              {parseFloat(loftyitemvariable_global_carriton0fqi?.cartitem?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
          
      </div>
      
            </div>
            
        <div className="" id="ipbwdg">
          
      <form
        id="ir0jbb"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createordenesdecomprabokst({
						token: 'aasdas',
						nombredelapersonai1agl: e.target.nombredelapersonai1agl?.value,
						correov25ao: e.target.correov25ao?.value,
						direccindelapersonahbgqc: e.target.direccindelapersonahbgqc?.value,
						telefonol60a6i: e.target.telefonol60a6i?.value,
					});
				} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="i296uj" className="">
      
      <label id="ioh0np" className="">
      <>Nombre y Apellido</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombredelapersonai1agl"
        type="text"
        placeholder="Pedro Juarez"
        className="form-control "
        id="i07ehq"
      />
      
      </div>
      
      <div id="iqvn9m" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correov25ao"
        type="text"
        placeholder="tu@correo.com"
        className="form-control "
        id="ivgkja"
      />
      
      </div>
      
      <div id="iqgdjl" className="">
      
      <label id="i5ov73" className="">
      <>Dirección </>
      </label>
      
      <br className="" id="" />
      
      <input
        name="direccindelapersonahbgqc"
        type="text"
        placeholder="no casa, colonia y ciudad"
        className="form-control "
        id="ivalwi"
      />
      
      </div>
      
      <div id="i816na" className="">
      
      <label id="" className="">
      <>Telefono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telefonol60a6i"
        type="text"
        placeholder="9999-9999"
        className="form-control "
        id="irybxx"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="iorzod"
        className=""
        
      >
      
      <div id="iuejcg" className="">
      <>Comprar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div className="" id="iyo7r6">
        <>Sabores auténticos de Honduras. Tradición, calidad y amor en cada platillo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="i78qcc">
        <>+504 9999-9999</>
      </div>
      
      <div className="" id="il1rnw">
        <>info@correo.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_carriton0fqi_app: (value) => dispatch(set_lofty_global_carriton0fqi(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcarritodecomprasg8pi6);
  